import './images/proenem-logo.svg';
import './index.scss';
import { MediaQuery } from 'utils/media_query';
import { fetchProenemRedirectUrl } from 'utils/proenem_redirect';

const NAV_CTA_SELECTOR = '.js-proenem-nav-cta';
const MOBILE_NAV_CTA_ID = 'js-proenem-mobile-nav-cta';
const MODAL_CTA_SELECTOR = '#cta-proenem-sso';
const MODAL_SELECTOR = '#js-proenem-modal';

function closeMobileMenu() {
  if (MediaQuery.is('lt_header_lg_breakpoint')) {
    $('#segments-toggle-input').prop('checked', false);
    $('body').removeClass('q-no-scroll q-mobile-menu-open');
  }
}

function navCtaClickSource(target) {
  return target.id === MOBILE_NAV_CTA_ID ? 'navbar mobile menu' : 'navbar';
}

function armCta($cta) {
  $cta.data('redirecting', true);
  $cta.data('original-html', $cta.html());
  $cta.prop('disabled', true);
  $cta.attr('aria-busy', 'true');
  $cta.addClass('is-loading');
  $cta.text('Redirecionando...');
}

function releaseCta($cta) {
  const originalHtml = $cta.data('original-html');

  if (originalHtml) {
    $cta.html(originalHtml);
  }

  $cta.data('redirecting', false);
  $cta.prop('disabled', false);
  $cta.removeAttr('aria-busy');
  $cta.removeClass('is-loading');
  $cta.removeData('original-html');
}

// Analytics must never block a redirect: a missing or broken tracker only gets
// reported, the caller carries on.
function emitEvent(eventName, data) {
  try {
    window.UserTracker.emit('event', { eventName, data });
  } catch (trackerErr) {
    Rollbar.error(`Erro ao emitir evento ${eventName}`, trackerErr);
  }
}

async function redirectToProenem($cta, clickSource) {
  // Minting an SSO token + emitting analytics + navigating is not idempotent,
  // and the awaited fetch leaves a window where a second click would fire it
  // all again. Ignore re-clicks while a redirect is already in flight.
  if ($cta.data('redirecting')) {
    return;
  }
  armCta($cta);

  try {
    const sourceUrl = window.location.href;

    emitEvent('proenem redirect clicked', {
      'click source': clickSource,
      'source url': sourceUrl
    });

    const redirectUrl = await fetchProenemRedirectUrl();

    if (!redirectUrl) {
      releaseCta($cta);
      toastr.error(
        'Não foi possível conectar ao ProEnem. Tente novamente em instantes.'
      );
      return;
    }

    window.location.href = redirectUrl;
  } catch (err) {
    releaseCta($cta);
    Rollbar.error('Erro ao redirecionar para ProEnem', err);
  }
}

$(document).on('click', NAV_CTA_SELECTOR, function (e) {
  e.preventDefault();

  const clickSource = navCtaClickSource(e.currentTarget);
  const $modal = $(MODAL_SELECTOR);

  emitEvent('proenem nav cta clicked', { 'click source': clickSource });

  // The CTA lives in the shared Header, which more layouts render than the ones
  // rendering this modal. jQuery no-ops on an empty set, so without this guard
  // the button would silently do nothing on such a layout. The modal is an
  // upsell surface, not a hard dependency: send the user straight to ProEnem
  // and report the misconfigured layout instead of dead-ending the click.
  if ($modal.length === 0) {
    Rollbar.error(
      'Modal ProEnem ausente no layout; redirecionando direto',
      { 'click source': clickSource }
    );
    redirectToProenem($(e.currentTarget), clickSource);
    return;
  }

  closeMobileMenu();
  $modal.modal('show');
});

// Delegated handler: the modal markup is rendered by the layout, so we bind
// on `document` rather than the (possibly not-yet-present) button itself.
$(document).on('click', MODAL_CTA_SELECTOR, function (e) {
  e.preventDefault();

  redirectToProenem($(this), 'navbar proenem modal');
});
